import classNames from "classnames";
import { useEffect, useRef, useState } from "react";

import { Icon } from "src/app/components/icon/Icon";

import ddCss from "./Dropdown.module.css";

const Dropdown = ({
  items,
  activeItemValue,
  defaultItem,
  placeholder,
  removePlaceholder,
  customCss,
  handleChange,
}: {
  items: Array<any>;
  activeItemValue: number | string | undefined;
  defaultItem: any;
  placeholder: string;
  removePlaceholder: boolean;
  customCss: string;
  handleChange: (value: number) => void;
}) => {
  const [open, setOpen] = useState(false);
  const container = useRef<any>(null);
  const [showChildren, setShowChildren] = useState(false);

  const handleClickOutside = (event: MouseEvent) => {
    if (container.current && !container.current.contains(event.target)) {
      setOpen(false);
    }
  };

  const handleSelect = (value: number) => {
    setOpen(false);
    setShowChildren(false);
    handleChange(value);
  };

  const findActiveItem = () => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].value === activeItemValue) {
        return items[i].text;
      } else if (items[i].children !== undefined && items[i].children.length > 0) {
        for (let j = 0; j < items[i].children.length; j++) {
          if (items[i].children[j].value === activeItemValue) {
            return items[i].children[j].text;
          }
        }
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  return (
    <div className={classNames(customCss, ddCss.dropdownContainer, open ? ddCss.dropdownActive : "")} ref={container}>
      <div
        className={classNames("u-w100", "dropdown-button", "u-cursor-pointer", ddCss.dropdownButton)}
        onClick={() => (items?.length > 1 ? setOpen(!open) : null)}
      >
        <span className={ddCss.dropdownText}>{activeItemValue === 0 ? placeholder : findActiveItem()}</span>

        <Icon name={open ? "arrow-up" : "arrow-down"} className="u-t-f24p u-t-primary u-pos-absolute u-right20px" />
      </div>
      <hr className={classNames("u-bt0", "u-zindex2", "u-bl0", "u-br0", ddCss.lineBreak, open ? "" : "u-none")} />
      {open && (
        <div className={classNames("dropdown-wrapper", ddCss.dropdownWrapper)}>
          <ul className={ddCss.dropdownMenu}>
            {defaultItem && (
              <li
                key={defaultItem.value}
                className={classNames("u-cursor-pointer", ddCss.menuItem, defaultItem.value === activeItemValue ? "u-none" : "")}
                onClick={() => handleSelect(defaultItem.value)}
              >
                {defaultItem.text}
              </li>
            )}

            {items.map((item) => {
              if (item.children != null && item.children.length > 0) {
                return (
                  <div>
                    <li
                      key={item.value}
                      className={classNames("u-cursor-pointer", ddCss.menuItem, item.value === activeItemValue ? "u-none" : "")}
                      onClick={() => setShowChildren(!showChildren)}
                    >
                      {item.text}
                      <Icon name={showChildren ? "arrow-up" : "arrow-down"} className="u-t-f24p u-t-primary u-pos-absolute u-right20px" />
                    </li>
                    {showChildren === true &&
                      item.children.map((child: any) => {
                        return (
                          <li
                            key={child.value}
                            className={classNames("u-cursor-pointer", ddCss.menuItemChild, child.value === activeItemValue ? "u-none" : "")}
                            onClick={() => handleSelect(child.value)}
                          >
                            {child.text}
                          </li>
                        );
                      })}
                  </div>
                );
              } else {
                return (
                  <li
                    key={item.value}
                    className={classNames("u-cursor-pointer", ddCss.menuItem, item.value === activeItemValue ? "u-none" : "")}
                    onClick={() => handleSelect(item.value)}
                  >
                    {item.text}
                  </li>
                );
              }
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
